import { render } from "./AgentePickMpio.vue?vue&type=template&id=4d23a163"
import script from "./AgentePickMpio.vue?vue&type=script&lang=ts"
export * from "./AgentePickMpio.vue?vue&type=script&lang=ts"
script.render = render

export default script